import * as React from "react";
const SvgFiRrDna = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dna_svg__a)">
      <path
        fill="#062147"
        d="M16.569 13.572a.999.999 0 1 0-1.139 1.643q.56.388 1.048.784H7.523c1.437-1.168 3.179-2.136 4.962-3.126C16.945 10.395 22 7.587 22 .999a1 1 0 1 0-2 0q0 .519-.05 1H4.047a11 11 0 0 1-.047-1 1 1 0 1 0-2 0c0 5.021 2.902 7.676 5.431 9.428a.997.997 0 0 0 1.391-.253 1 1 0 0 0-.253-1.391q-.56-.388-1.048-.784h8.956c-1.437 1.168-3.179 2.136-4.962 3.126C7.055 13.603 2 16.411 2 22.999a1 1 0 1 0 2 0q0-.519.05-1h15.903q.047.486.047 1a1 1 0 1 0 2 0c0-5.021-2.902-7.675-5.431-9.427M5.565 6a7.8 7.8 0 0 1-1.079-2h15.013a8 8 0 0 1-1.076 2zM4.501 20a8 8 0 0 1 1.076-2h12.858a7.8 7.8 0 0 1 1.079 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dna_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDna;
